import './Guarantees.css'

const ITEMS = [
  {
    label: 'Animaux vaccinés & vérifiés',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    ),
  },
  {
    label: 'Pédigrées officiels LOF/LOOF',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4"/><path d="M10 14l2 2 4-4"/>
      </svg>
    ),
  },
  {
    label: 'Livraison internationale sécurisée',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 3L3 10.5l7.5 3L13.5 21 21 3z"/><path d="M10.5 13.5L21 3"/>
      </svg>
    ),
  },
  {
    label: 'Paiement 100% sécurisé',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 10h18"/>
      </svg>
    ),
  },
  {
    label: 'Garantie arrivée en vie',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4v5h5"/><path d="M20 20v-5h-5"/>
        <path d="M4.5 15a8 8 0 0 0 14-4"/><path d="M19.5 9a8 8 0 0 0-14 4"/>
      </svg>
    ),
  },
  {
    label: 'Support 7j/7',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.5 8.5 0 1 1 21 11.5z"/>
      </svg>
    ),
  },
]

export default function Guarantees() {
  return (
    <section className="guarantees">
      <div className="guarantees-inner">
        {ITEMS.map((item, i) => (
          <div key={i} className="guarantee-item">
            {item.icon}
            <span className="guarantee-label">{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  )
}